import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { Modal, modalClasses, ModalContent, Typography } from "@kaltura/ds-react-components";
import { FileRow } from "@kaltura/mediaspace-shared-upload";

export const StyledImportModalContent = styled(ModalContent)(({ theme }) => ({
    overflow: "auto",
    flex: "1 1 auto",
}));

export const StyledEditModalContent = styled(ModalContent)(({ theme }) => ({
    overflow: "auto",
    flex: "1 1 auto",
}));

export const StyledBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
}));

export const PreviewPlaceholder = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: "relative",
    width: "100%",
    height: 0,
    paddingBottom: "56.25%", // 16:9 aspect ratio
    backgroundColor: theme.kaltura.palette.tone7, // Light gray background for preview
    borderRadius: theme.kaltura.shape.roundness2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const PreviewLabel = styled(Typography)(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: theme.kaltura.palette.tone1,
}));

export const StyledModal = styled(Modal)<{ editSizedModal?: boolean }>(({ theme, editSizedModal = false }) => ({
    [`& .${modalClasses.paper}`]: {
        width: editSizedModal ? "790px" : "584px",
        maxWidth: editSizedModal ? "790px" : "584px",
        maxHeight: "85vh",
        display: "flex",
        flexDirection: "column",
        overflowY: "hidden",
        [theme.breakpoints.down("sm")]: {
            minWidth: "100%",
            width: "100%",
            margin: 0,
            borderRadius: 0,
            height: "100%",
        },
    },
}));

export const StyledFileRow = styled(FileRow)(({ theme }) => ({
    width: "100%",
}));

export const PreviewContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: "relative",
    width: "100%",
}));

export const VideoContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    paddingBottom: "56.25%", // 16:9 aspect ratio
    height: 0,
    overflow: "hidden",
    borderRadius: theme.shape.borderRadius,
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.kaltura.palette.tone7,
}));

export const VideoTitle = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(1),
    fontWeight: "bold",
}));

export const PlayerContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    paddingBottom: "56.25%", // 16:9 aspect ratio
    height: 0,
    overflow: "hidden",
    borderRadius: theme.kaltura.shape.roundness2,
}));

export const PlayerStyledBox = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down(theme.breakpoints.values.xs)]: {
        width: "100%",
        height: "100%",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.kaltura.palette.tone7,
        borderRadius: theme.kaltura.shape.roundness2,
    },
}));
export const StyledInnedContainer = styled("div")(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
}));

/**
 * actions inside the actions bar
 */
export const StyledActions = styled("div")<{
    hasBackButton?: boolean;
}>(({ theme, hasBackButton = false }) => ({
    display: "flex",
    justifyContent: hasBackButton ? "space-between" : "flex-end",
    width: "100%",
}));

/**
 * buttons inside the actions
 */
export const StyledActionButtons = styled("span")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
}));
